import { IconProps } from "../../utils/global-types/global-types";

const HubspotLogoIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    fill="none"
    className={className ? className : "w-7 h-7"}
    {...rest}
  >
    <path
      d="M20.125 10.207V7.762a2.03 2.03 0 0 0 1.168-1.83v-.06a2.03 2.03 0 0 0-2.028-2.028h-.06a2.03 2.03 0 0 0-2.03 2.028v.06c0 .79.457 1.472 1.12 1.804v2.47a5.58 5.58 0 0 0-2.516 1.285l-6.64-5.172a2.37 2.37 0 0 0 .072-.558 2.373 2.373 0 1 0-2.374 2.374c.46 0 .886-.135 1.25-.363l6.524 5.08A5.57 5.57 0 0 0 13.7 15.13a5.58 5.58 0 0 0 .98 3.15l-1.924 1.924a1.8 1.8 0 0 0-.546-.094 1.82 1.82 0 1 0 1.82 1.82 1.8 1.8 0 0 0-.097-.552l1.894-1.895a5.58 5.58 0 1 0 4.298-9.276Zm-.795 8.29a2.77 2.77 0 1 1 0-5.539 2.77 2.77 0 0 1 0 5.54Z"
      fill="#FF7A59"
    />
  </svg>
);

export default HubspotLogoIcon;
